export default __webpack_public_path__ + "static/media/postcard_back.f38a67ae.svg";